import { render, staticRenderFns } from "./SheetRowDetails.vue?vue&type=template&id=bbbdd7d4&scoped=true&"
import script from "./SheetRowDetails.vue?vue&type=script&lang=js&"
export * from "./SheetRowDetails.vue?vue&type=script&lang=js&"
import style0 from "./SheetRowDetails.vue?vue&type=style&index=0&id=bbbdd7d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbdd7d4",
  null
  
)

export default component.exports